import { Grid, TextField } from '@mui/material'
import { useAppSelector } from './RunReduxHooks'
import { selectProcHeader } from './sliceRunProcHeader'


const dsx = {
    label: { WebkitTextFillColor: "black", fontSize: 22 },
    '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: 'black', fontWeight: 'bold', fontSize: 18 }
}


export default function UIAssessmentVentParameters() {
    const procHeader = useAppSelector(selectProcHeader)

    return (
        <Grid container spacing={1} >
            <Grid item xs={3}>
                <TextField sx={dsx} variant='standard' disabled value={procHeader!.assessmentVV_mL!.toFixed(0) + ' ml'}
                    label='Assessment Ventilation Tidal Volume' fullWidth />
            </Grid>
            <Grid item xs={3}>
                <TextField sx={dsx} variant='standard' disabled value={5}
                    label={<>PEEP (cm H<sub>2</sub>O)</>} fullWidth />
            </Grid>
            <Grid item xs={3} >
                <TextField sx={dsx} variant='standard' disabled value={10}
                    label='Respiratory Rate (bpm)' fullWidth />
            </Grid>
            <Grid item xs={3}>
                <TextField sx={dsx} variant='standard' disabled value={'100%'}
                    label={<>FiO<sub>2</sub></>} fullWidth/>
            </Grid>
        </Grid>
    )
}